// Shared SVG gradients for the 3D icons. Mounted once in App; CSS strokes icons with url(#ft-g-<tone>).
// userSpaceOnUse over lucide's 24x24 box, so straight lines (zero-size bounding boxes) still paint.
const TONES = {
  blue: ["#7aa5f5", "#3a6ab6"],
  violet: ["#b9a2fb", "#7357e8"],
  mint: ["#5fe0ae", "#169a83"],
  peach: ["#fdab6a", "#e0661f"],
  pink: ["#f79ac8", "#d94489"],
  sky: ["#6fd0fa", "#3b74e6"],
};

export default function IconGradients() {
  return (
    <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true" focusable="false">
      <defs>
        {Object.entries(TONES).map(([name, [from, to]]) => (
          <linearGradient key={name} id={`ft-g-${name}`} gradientUnits="userSpaceOnUse" x1="2" y1="2" x2="22" y2="22">
            <stop offset="0" stopColor={from} />
            <stop offset="1" stopColor={to} />
          </linearGradient>
        ))}
      </defs>
    </svg>
  );
}
